// extracted by mini-css-extract-plugin
module.exports = {"right":"styles__right___3aVV1"};